import { DeleteProposalGroupInput, GetProposalQuery } from '@/gql/graphql';
import { produce } from 'immer';

import { enforceSingleMultiChoiceWinner } from './proposalSectionTree';

/**
 * Removes the group and every descendant. Removing a sub-group can unsettle a
 * MULTI_CHOICE parent's single winner, so the parent's selection is re-settled to
 * mirror the server. Totals are left untouched.
 */
export const applyProposalGroupDeletion = (
  data: GetProposalQuery,
  input: DeleteProposalGroupInput
): GetProposalQuery =>
  produce(data, (draft) => {
    for (const section of draft.proposal.sections) {
      if (section.__typename !== 'ProposalItemGroupSection') continue;

      const topLevelIndex = section.groups.findIndex(
        (group) => group.key === input.groupKey
      );
      if (topLevelIndex !== -1) {
        section.groups.splice(topLevelIndex, 1);
        return;
      }

      for (const group of section.groups) {
        const subGroupIndex = group.children.findIndex(
          (child) =>
            child.__typename === 'ProposalItemGroup' &&
            child.key === input.groupKey
        );
        if (subGroupIndex !== -1) {
          group.children.splice(subGroupIndex, 1);
          enforceSingleMultiChoiceWinner(group.children, group.selectionMode);
          return;
        }
      }
    }
  });
